<div class="header">
  <strong>NOME</strong>
  <strong>DATA DE CRIAÇÃO</strong>
  <strong>ÚLTIMA ATUALIZAÇÃO</strong>
  <strong>CLIENTE</strong>
  <strong>STATUS</strong>
  <strong *ngIf="hasSupervisorRole">AÇÕES</strong>
</div>
